import { useEstimatedUnbillFigureVM } from "presentation/hook/EstimatedUnbillFigure/useEstimatedUnbillFigureVM";
import { useEstimatedUnbillFigureTracked } from "presentation/store/EstimatedUnbillFigure/EstimatedUnbillFigureProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import EstimatedUnbillFigureEditPanel from "./EstimatedUnbillFigureEditPanel";
import EstimatedUnbillFigureTablePanel from "./EstimatedUnbillFigureTablePanel";


const EstimatedUnbillFigureMaintenance: React.FC = () => {
    const [estimatedUnbillFigureState] = useEstimatedUnbillFigureTracked();
    const [isLoading, setIsLoading] = useState(true);
    const estimatedUnbillFigureVM = useEstimatedUnbillFigureVM();
    const { isShowEditPanel } = estimatedUnbillFigureState;


    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    estimatedUnbillFigureVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            estimatedUnbillFigureVM.searchAllEstimatedUnbillFigureList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [estimatedUnbillFigureVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>

            {!(isShowEditPanel) && <>
                <EstimatedUnbillFigureTablePanel /></>}
            {(isShowEditPanel) &&
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={"100%"}
                    rightSectionWidth={"0%"}
                    leftChildren={<EstimatedUnbillFigureEditPanel />}
                />}
        </div>
    </>
}

export default memo(EstimatedUnbillFigureMaintenance);